import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const auth = sessionStorage.getItem("token");
  return auth ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
